/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Moved_To_Requested_LabelInputs */

const en_samples_moved_to_requested_label = /** @type {(inputs: Samples_Moved_To_Requested_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moved to Requested`)
};

const es_samples_moved_to_requested_label = /** @type {(inputs: Samples_Moved_To_Requested_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Movida(s) a Solicitado`)
};

/**
* | output |
* | --- |
* | "Moved to Requested" |
*
* @param {Samples_Moved_To_Requested_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_moved_to_requested_label = /** @type {((inputs?: Samples_Moved_To_Requested_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Moved_To_Requested_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_moved_to_requested_label(inputs)
	return es_samples_moved_to_requested_label(inputs)
});